import styled, { keyframes } from 'styled-components';

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;
const appearBackground = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: rgba(0, 0, 0, 0.5);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 7;
  animation: ${appearBackground} 0.5s;
  transition: ${appearBackground} 0.5s;

  .active {
    opacity: 1;
    top: 30%;
    visibility: visible;
    animation: ${appearFromTop} 0.4s;

    @media (max-width: 650px) {
      animation: ${appearFromTop} 0.4s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  top: -500px;
  position: fixed;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  opacity: 0;
  border-radius: 5px;
  padding: 20px 40px;
  visibility: hidden;
  transition: all 0.5s ease-out;

  > h1 {
    font-weight: 500;
  }
  > h2 {
    margin-left: 10px;
    color: #455a64;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		width: 97%;
		padding: 5px 10px;
	}
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;

  h1 {
    font-size: 22px;
    font-weight: 500;
  }
  h2 {
    font-size: 18px;
    font-weight: 500;
    color: #607d8b;
  }
`;

export const AcessoDados = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 5px 10px;

  h1 {
    font-size: 18px;
    font-weight: 500;
  }
  h2 {
    font-size: 18px;
    color: #607d8b;
    font-weight: 500;
  }
`;

export const ButtonsView = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 30px 10px 0;
  width: 100%;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 600;
    padding: 10px 30px;
    border-radius: 10px;
  }
  button.btn-cancel {
    border: 2px solid var(--azul-razio);
    color: var(--azul-razio);
    margin-right: 20px;
  }
  button.btn-save {
    border: 2px solid var(--azul-razio);
    background-color: var(--azul-razio);
    padding: 10px 40px;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		padding: 20px 10px 10px;
	}
`;
